module.exports = __webpack_public_path__ + "media/fonts/FontAwesome-d820815b6046c7bd3305d6941603433f.otf";